import { render, staticRenderFns } from "./DocumentCreateEditModal.vue?vue&type=template&id=5b3c111f&scoped=true&"
import script from "./DocumentCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c111f",
  null
  
)

export default component.exports